import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { LUXURY_GTM_CONTAINER_ID } from './data-layer.types';

const GTM_SCRIPT_ID = 'handel-gtm-script';

type DataLayerHost = typeof globalThis & {
  dataLayer?: Record<string, unknown>[];
};

@Injectable({ providedIn: 'root' })
export class GtmLoaderService {
  private injected = false;

  start(): void {
    ensureDataLayer();
    this.injectContainer();
  }

  private injectContainer(): void {
    const containerId = environment.gtmContainerId.trim();
    if (
      this.injected ||
      !environment.production ||
      containerId !== LUXURY_GTM_CONTAINER_ID ||
      typeof document === 'undefined'
    ) {
      return;
    }
    if (document.getElementById(GTM_SCRIPT_ID)) {
      this.injected = true;
      return;
    }

    ensureDataLayer().push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.id = GTM_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
    document.head.appendChild(script);
    this.injected = true;
  }
}

function ensureDataLayer(): Record<string, unknown>[] {
  const host = globalThis as DataLayerHost;
  host.dataLayer ??= [];
  return host.dataLayer;
}
